import Api from "../Api/Api";

export const getEvents = (search,page,page_size,sort_by,event_status) => {
  return Api.get(`event/getEvents?search=${search}&page_no=${page}&page_size=${page_size}&sort_by=${sort_by}&event_status=${event_status}`);
};

export const getEventDetails = (data) => {
  return Api.get(`event/getEvents?event_id=${data}`);
};

export const getEventQuestions = (data) => {
  return Api.get(`event/getQuestions?event_id=${data}`);
};

export const getEventPayout = (data) => {
  return Api.get(`admin/getEventPayout?event_id=${data}`);
};
